module.exports = __webpack_public_path__ + "img/marker-arrangement-group.bf0e9017.svg";